import {
  formatDate as fd
} from "@utils";

let formatDate = function(value, fmt) {
  return fd(value, fmt);
};

export default {
  formatDate
}



// WEBPACK FOOTER //
// ./src/filters/index.js